// src/theme.js
import { createTheme } from "@mui/material/styles";
import TajawalBold from "../assets/fonts/tajawal/Tajawal-Bold.ttf";
import TajawalRegular from "../assets/fonts/tajawal/Tajawal-Regular.ttf";
import TajawalLight from "../assets/fonts/tajawal/Tajawal-ExtraLight.ttf";
import TajawalBlack from "../assets/fonts/tajawal/Tajawal-Black.ttf";

const theme = createTheme({
  palette: {
    background: {
      default: "white",
      paper: "#ffffff",
    },
    text: {
      primary: "#333333",
      secondary: "#757575",
    },
    navItem: {
      main: "#0A5192",
    },
    button: {
      primary: "#3173B1", //button background color primary light blue
      secondary: "#3173B1", //blue
      light: "#ffffff", //white
      dark: "#000000", //black
    },
  },
  typography: {
    fontFamily: "Tajawal-Regular, Arial, sans-serif", // Set Tajawal as the default font
    fontWeightRegular: 400,
    fontWeightBold: 700,
    fontWeightBlack: 900,
    h1: {
      fontSize: "2.5rem",
      fontWeight: 500,
    },
    h2: {
      fontSize: "2rem",
      fontWeight: 500,
    },
    body1: {
      fontSize: "1rem",
    },
    button: {
      textTransform: "none",
    },
  },

  shape: {
    borderRadius: 8, // Adjust globally for components
  },
  components: {
    MuiTextField: {
      styleOverrides: {
        root: {
          "& .MuiInputBase-root": {
            backgroundColor: "white", // Set background color here
          },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          padding: "8px 16px",
        },
      },
    },
    MuiStepIcon: {
      styleOverrides: {
        root: {
          color: "#cccccc", // Default color
          "&.Mui-active": {
            color: "#3173B1", // Active color
          },
          "&.Mui-completed": {
            color: "#3173B1", // Completed color
          },
        },
      },
    },
    MuiStepLabel: {
      styleOverrides: {
        label: {
          color: "#004D8A", // Default label color
          "&.Mui-active": {
            color: "#3173B1", // Active label color
          },
          "&.Mui-completed": {
            color: "#3173B1", // Completed label color
          },
        },
      },
    },
    MuiCssBaseline: {
      styleOverrides: `
        @font-face {
          font-family: 'Tajawal-Regular';
          font-style: normal;
          font-display: swap;
          font-weight: 400;
          src: local('Tajawal-Regular'), url(${TajawalRegular}) format('truetype');
        }
        @font-face {
          font-family: 'Tajawal-Bold';
          font-style: normal;
          font-display: swap;
          font-weight: 700;
          src: local('Tajawal-Bold'), url(${TajawalBold}) format('truetype');
        }
        @font-face {
          font-family: 'Tajawal-Light';
          font-style: normal;
          font-display: swap;
          font-weight: 100;
          src: local('Tajawal-Light'), url(${TajawalLight}) format('truetype');
        }
          @font-face {
          font-family: 'Tajawal-Black';
          font-style: normal;
          font-display: swap;
          font-weight: 200;
          src: local('Tajawal-Black'), url(${TajawalBlack}) format('truetype');
        }
      `,
    },
  },
});

export default theme;
